export default {
  fontSize: 10,
  htmlFontSize : 12,
  h1: {
    fontWeight: 500,
    fontSize: 30,
    letterSpacing: '-0.24px'
  },
  h2: {
    fontWeight: 500,
    fontSize: 25,
    letterSpacing: '-0.24px'
  },
  h3: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 500,
    fontSize: 17,
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 12,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  }
};
